import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore, } from '@mcn-platform/models';
import StatelessBackgroundImage from './StatelessBackgroundImage';
import assetGetData from '../../portal/common/asset/assetGetData';
const BackgroundImage = ({ backgroundImage, opacity, children, alignItems, }) => {
    const store = useStore();
    const asset = backgroundImage?.assetId
        ? store.getOrLoad('asset', backgroundImage.assetId)
        : undefined;
    const [url, setUrl] = useState('');
    const [altText, setAltText] = useState('');
    useEffect(() => {
        if (!asset) {
            return;
        }
        const precachedUrl = asset?.getPrecachedUrl?.('original');
        if (precachedUrl) {
            setUrl(precachedUrl);
            setAltText(asset.name || '');
        }
        else if (asset?.status === 'processed') {
            asset.getSignedUrl('original').then(({ url: signedUrl }) => {
                setUrl(signedUrl);
                setAltText(asset.name || '');
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [backgroundImage?.assetId, asset?.id, asset?.updatedAt, asset?.status]);
    if (!backgroundImage?.assetId) {
        return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        _jsx(_Fragment, { children: children }));
    }
    return (_jsx(StatelessBackgroundImage, { fit: backgroundImage.fit, imageUrl: url, alt: altText, opacity: opacity, alignItems: alignItems, children: children }));
};
BackgroundImage.defaultProps = {
    opacity: undefined,
    alignItems: undefined,
    children: null,
};
BackgroundImage.getData = async ({ backgroundImage, }, store) => (assetGetData(backgroundImage.assetId, 'original', store));
export default observer(BackgroundImage);
//# sourceMappingURL=BackgroundImage.js.map